/**
 * 提供基本的事件绑定、解绑和触发
 *
 * @example
 *
 *      方式一：直接实例化
 *          var object = new Events();
 *          object.on('expand', function() {
 *          });
 *
 *          object.trigger('expand');
 *
 *      方式二：混入到其他类中
 *          function Dog() {}
 *          Events.mixTo(Dog);
 *
 *          Dog.prototype.sleep = function() {
 *              this.trigger('sleep');
 *          }
 *
 *          var dog = new Dog();
 *          dog.on("sleep", function() {
 *          });
 *          dog.sleep();
 */
define(function() {
    var eventSplitter = /\s+/;

    var keys = Object.keys;
    if (!keys) {
        keys = function(o) {
            var result = [];

            for (var name in o) {
                if (o.hasOwnProperty(name)) {
                    result.push(name);
                }
            }
            return result;
        };
    }

    function isFunction(func) {
        return Object.prototype.toString.call(func) === '[object Function]';
    }

    // 事件添加、删除和触发
    function Events() {
    }

    /**
     * 监听事件
     *
     * @param {String|Null} events 空格分离的事件名称，缺省为message
     * @param {Function} callback 事件触发的回调函数
     * @param {Object|Null} context 执行回调函数的上下文
     */
    Events.prototype.on = function(events, callback, context) {
        var event, cache, list;
        if (!callback) return this;

        cache = this.__events || (this.__events = {});
        events = events.split(eventSplitter);

        while (event = events.shift()) {
            list = cache[event] || (cache[event] = []);
            list.push(callback, context);
        }

        return this;
    };

    /**
     * 只触发一次事件
     *
     * @param {String|Null} events 空格分离的事件名称，缺省为message
     * @param {Function} callback 回调函数
     * @param {Object|Null} context 回调函数的执行上下文
     */
    Events.prototype.once = function(events, callback, context) {
        var that = this;
        var cb = function() {
            that.off(events, cb);
            callback.apply(context || that, arguments);
        };
        return this.on(events, cb, context);
    };

    /**
     * 解绑事件
     *
     * @param {String|Null} events 空格分离的事件名称
     * @param {Function|Null} callback 回调函数
     * @param {Object|Null} context 执行回调函数的上下文
     * @example
     *
     *      // 移除change事件的onChange回调
     *      object.off("change", onChange);
     *
     *      // 移除change事件的所有回调
     *      object.off("change");
     *
     *      // 移除所有事件的onChange回调
     *      object.off(null, onChange);
     *
     *      // 移除上下文为context的所有事件的所有回调
     *      object.off(null, null, context);
     *
     *      // 移除object对象上的所有事件
     *      object.off();
     */
    Events.prototype.off = function(events, callback, context) {
        var cache, event, list, i;

        if (!(cache = this.__events)) return this;
        if (!(events || callback || context)) {
            delete this.__events;
            return this;
        }

        events = events ? events.split(eventSplitter) : keys(cache);

        while (event = events.shift()) {
            list = cache[event];
            if (!list) continue;

            if (!(callback || context)) {
                delete cache[event];
                continue;
            }

            for (i = list.length - 2; i >= 0; i -= 2) {
                if (!(callback && list[i] !== callback ||
                    context && list[i + 1] !== context)) {
                    list.splice(i, 2);
                }
            }
        }

        return this;
    };

    /**
     * 触发事件
     *
     * @param {String} events 空格分离的事件名称
     */
    Events.prototype.trigger = function(events) {
        var cache, event, list, i, len, rest = [], returned = true;
        if (!(cache = this.__events)) return this;

        events = events.split(eventSplitter);

        // 遍历获取参数
        for (i = 1, len = arguments.length; i < len; i++) {
            rest[i - 1] = arguments[i];
        }

        while (event = events.shift()) {
            // Copy callback lists to prevent modification.
            if (list = cache[event]) list = list.slice();

            returned = triggerEvents(list, rest, this) && returned;
        }

        return returned;
    };

    Events.prototype.emit = Events.prototype.trigger;

    /**
     * 将事件功能混入到其他类中
     *
     * @param {Function|Object} receiver
     */
    Events.mixTo = function(receiver) {
        var proto = Events.prototype,
            key;

        if (isFunction(receiver)) {
            for (key in proto) {
                if (proto.hasOwnProperty(key)) {
                    receiver.prototype[key] = proto[key];
                }
            }
        } else {
            var event = new Events();
            for (key in proto) {
                if (proto.hasOwnProperty(key)) {
                    copyProto(key);
                }
            }
        }

        function copyProto(key) {
            receiver[key] = function() {
                proto[key].apply(event, Array.prototype.slice.call(arguments));
                return this;
            };
        }
    };

    // Execute callbacks
    function triggerEvents(list, args, context) {
        var pass = true;

        if (list) {
            var i = 0, l = list.length, a1 = args[0], a2 = args[1], a3 = args[2];
            // call is faster than apply, optimize less than 3 argu
            // http://blog.csdn.net/zhengyinhui100/article/details/7837127
            switch (args.length) {
                case 0: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context) !== false && pass; } break;
                case 1: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context, a1) !== false && pass; } break;
                case 2: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass; } break;
                case 3: for (; i < l; i += 2) { pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass; } break;
                default: for (; i < l; i += 2) { pass = list[i].apply(list[i + 1] || context, args) !== false && pass; } break;
            }
        }
        // trigger will return false if one of the callbacks return false
        return pass;
    }

    return Events;
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/cui/core/events/events.js
 ** module id = 29
 ** module chunks = 13 14
 **/